//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, FreeMode } from "swiper/modules";

export default class PageJS {
    constructor(common) {
        this.common = common;
        this.BREAK_SP = 767;
    }

    mq(type = "sp") {
        if (type === "sp") return `(max-width: ${this.BREAK_SP}px)`;
        if (type === "pc") return `(min-width: ${this.BREAK_SP + 1}px)`;
        return type;
    }

    init() {
        this._secAboutPc();
        this._secMenuSwiper();

        this.common.init();//common.jsはここでinitさせる
    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _secMenuSwiper_BK() {

        const sliderNames = [
            "menu_ex1_morning",
            "dinner",
        ];

        const createMenuSwiper = (name) => {

            const el = document.querySelector(`.${name}_swiper`);
            if (!el) return;

            const scrollbarEl = el.querySelector(`.swiper-scrollbar_${name}`);

            new Swiper(el, {
                modules: [Scrollbar, Navigation],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,

                navigation: {
                    nextEl: `.${name}_swiper-button-next`,
                    prevEl: `.${name}_swiper-button-prev`,
                },

                scrollbar: scrollbarEl
                    ? {
                        el: scrollbarEl,
                        draggable: true,
                    }
                    : undefined,
            });

        };

        sliderNames.forEach(createMenuSwiper);
    }

    _secAboutPc_BK() {
        const about = document.querySelector("#Features_area");
        if (!about) return;

        if (this._aboutPcMM) this._aboutPcMM.revert();
        this._aboutPcMM = gsap.matchMedia();

        this._aboutPcMM.add(this.mq("pc"), () => {
            const experTl_01 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#Features_area",
                    start: "top top",
                    end: "bottom bottom",
                    scrub: true,
                },
            });

            experTl_01
                .to("#Features_area .img_area .img1", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    //ease: "power4.inOut",
                    ease: "none",
                })
                .to("#Features_area .img_area .img2", {
                    duration: 1,
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                    //ease: "power4.inOut",
                    ease: "none",
                })
                // .to("#About_area .img_area .img3", {
                //     duration: 1,
                //     clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                //     ease: "power1.inOut",
                // })
                ;

            return () => {
                experTl_01.scrollTrigger?.kill();
                experTl_01.kill();
            };
        });
    }
    _secAboutPc() {
        const about = document.querySelector("#Features_area");
        if (!about) return;

        if (this._aboutPcMM) this._aboutPcMM.revert();
        this._aboutPcMM = gsap.matchMedia();

        this._aboutPcMM.add(this.mq("pc"), () => {

            const txtArea = about.querySelector(".txt_area");
            const txtIn = about.querySelector(".txt_area .in");
            const imgArea = about.querySelector(".img_area");
            if (!txtArea || !txtIn || !imgArea) return;

            const getMove = () => {
                return Math.max(0, txtIn.scrollHeight - imgArea.offsetHeight);
            };

            const experTl_01 = gsap.timeline({
                scrollTrigger: {
                    trigger: "#Features_area",
                    start: "top top",
                    //end: "bottom bottom",
                    end: () => "+=" + (window.innerHeight * 2),
                    //end: () => "+=" + getMove(),
                    scrub: true,
                    //markers: true,
                    pin: true,

                },
            });


            experTl_01
                // テキストを少し上へ
                .to(txtIn, {
                    y: () => -getMove(),
                    ease: "none",
                    duration: 3
                }, 0)

                // img1 → img2
                .to("#Features_area .img_area .img1", {
                    opacity: 0,
                    ease: "none",
                    duration: 1
                }, 1)
                .to("#Features_area .img_area .img2", {
                    opacity: 1,
                    ease: "none",
                    duration: 1
                }, 1)

                // img2 → img3
                // .to("#Features_area .img_area .img2", {
                //     opacity: 0,
                //     ease: "none",
                //     duration: 1
                // }, 1.6)
                // .to("#Features_area .img_area .img3", {
                //     opacity: 1,
                //     ease: "none",
                //     duration: 1,
                // }, 1.6);


            return () => {
                experTl_01.scrollTrigger?.kill();
                experTl_01.kill();
                gsap.set("#Features_area .txt_area", { clearProps: "transform" });
            };
        });
    }


    _secMenuSwiper() {
        const els = document.querySelectorAll(".menu_swiper");
        if (!els.length) return;

        els.forEach((el) => {
            const scrollbarEl = el.querySelector(".swiper-scrollbar");
            const nextEl = el.querySelector(".menu_swiper-button-next");
            const prevEl = el.querySelector(".menu_swiper-button-prev");

            const modules = [];
            const options = {
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
            };

            if (nextEl && prevEl) {
                modules.push(Navigation);
                options.navigation = {
                    nextEl,
                    prevEl,
                };
            }

            if (scrollbarEl) {
                modules.push(Scrollbar);
                options.scrollbar = {
                    el: scrollbarEl,
                    draggable: true,
                };
            }

            new Swiper(el, {
                modules,
                ...options,
            });
        });
    }


}